import React, { Fragment } from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: [string, number][] = [['Hours', hours], ['Minutes', minutes], ['Seconds', seconds]];
  return <div role="timer" aria-label={`Offer ends in ${minutes} minutes and ${seconds} seconds`} data-id="element-22" data-mp="3q0cga0mfqpnl">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-urgent" data-id="element-23" data-mp="3c130v361zzko">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="3h2jxunlf31vz" />
        This price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-25" data-mp="3259hp0xtx7tx">
        {units.map(([label, value], i) => <Fragment key={label} data-id="element-26" data-mp="374vvpclhes3s" data-mpi={i}>
            <div className="flex w-[78px] flex-col items-center rounded-xl border border-white/10 bg-ink py-2.5 sm:w-[92px]" data-id="element-27" data-mp="10btqa1tx3oxw">
              <span className="font-display text-[34px] font-black leading-none tabular-nums text-white sm:text-[40px]" data-id="element-28" data-mp="15a4zcace1vf2">
                {String(value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-white/55" data-id="element-29" data-mp="t124tl52pd10">{label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-3xl font-black text-white/40" aria-hidden="true" data-id="element-30" data-mp="12rd7l4d0tg6b">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}